import React from 'react'

import { SvgProps } from '../../model/types'

const OpenInNewIcon: React.FC<SvgProps> = props => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="currentColor"
			{...props}
		>
			<path d="M9.16667 5C9.62692 5 10 5.3731 10 5.83333C10 6.29357 9.62692 6.66667 9.16667 6.66667H4.16667V15.8333H13.3333V10.8333C13.3333 10.3731 13.7064 10 14.1667 10C14.6269 10 15 10.3731 15 10.8333V15.8333C15 16.7538 14.2538 17.5 13.3333 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V6.66667C2.5 5.74619 3.24619 5 4.16667 5H9.16667ZM16.6667 2.5C17.1269 2.5 17.5 2.8731 17.5 3.33333V7.5C17.5 7.96023 17.1269 8.33333 16.6667 8.33333C16.2064 8.33333 15.8333 7.96023 15.8333 7.5V5.34517L8.92258 12.2559C8.59717 12.5813 8.06952 12.5813 7.74407 12.2559C7.41864 11.9305 7.41864 11.4028 7.74407 11.0774L14.6548 4.16667H12.5C12.0398 4.16667 11.6667 3.79357 11.6667 3.33333C11.6667 2.8731 12.0398 2.5 12.5 2.5H16.6667Z" />
		</svg>
	)
}

export default OpenInNewIcon
